import React, { useEffect, useState } from 'react';
import { getAuth, onIdTokenChanged } from 'firebase/auth';
import { Spin } from 'antd';
import AccountLayout from '../layout/AccountLayout';
import { AccessNotice } from './AccessNotice';

export const AdminGate: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [status, setStatus] = useState<
    'loading' | 'allowed' | 'denied' | 'error'
  >('loading');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let generation = 0;
    const unsubscribe = onIdTokenChanged(getAuth(), async (user) => {
      generation += 1;
      const current = generation;
      setStatus('loading');
      try {
        const token = await user?.getIdTokenResult();
        if (current === generation)
          setStatus(token?.claims.admin === true ? 'allowed' : 'denied');
      } catch {
        if (current === generation) setStatus('error');
      }
    });
    return () => {
      generation += 1;
      unsubscribe();
    };
  }, [attempt]);
  if (status === 'allowed') return <>{children}</>;
  return (
    <AccountLayout pageTitle="Admin access">
      {status === 'loading' ? (
        <Spin aria-label="Checking admin access" />
      ) : (
        <AccessNotice
          title={
            status === 'error'
              ? 'We couldn’t check your admin access'
              : 'Admin access required'
          }
          description={
            status === 'error'
              ? 'Please try again to check your account permissions.'
              : 'This page is available to ToDesktop administrators. Switch to an administrator account to continue.'
          }
          hint="Need access? Contact your ToDesktop administrator."
          onRetry={
            status === 'error'
              ? () => setAttempt((value) => value + 1)
              : undefined
          }
        />
      )}
    </AccountLayout>
  );
};
